
function ModifyApplication(){
    return(
        <div className="form-body">
            <div className="row">
                <div className="col-md-12">
                    <h2 className="heading2 form-heading">Modify Application</h2>
                </div>
                <div className="col-md-6">
                    <div className="form-top-search"><input type="text" placeholder="LEI Number" /><button><i class="fas fa-search"></i></button></div>
                </div>                
                <div className="col-md-6 text-end">
                    <div className="form-top-search"><input type="text" placeholder="Refrence Number" /></div>
                </div>                
            </div> 
            <div className="form-content">
                <h3 className="heading3"><span>Entity information</span></h3>
                <ul>
                    <li>
                        <label>First &amp; Last Name <span>*</span></label><input type="text" placeholder="first &amp; last name of the authorized official" />
                    </li>
                    <li>
                        <label>Authorized Email ID <span>*</span></label><input type="text" placeholder="please enter email id" />
                    </li>
                    <li>
                        <label>Alternate Mail id <span>*</span></label><input type="text" placeholder="Alternate Mail id" />
                    </li>
                    <li>
                        <label>Alternate Mail id <span>*</span></label><input type="text" placeholder="authorized official contact number" />
                    </li>
                    <li>
                        <label>Alternate Contact Number <span>*</span></label><input type="text" placeholder="contact number" />
                    </li>
                    <li>
                        <label>Legal Name <span>*</span></label><input type="text" placeholder="please enter legal name" />
                    </li>
                    <li>
                        <label>Tax ID (PAN NO.) <span>*</span></label><input type="text" placeholder="pan number" />
                    </li>
                </ul>

                <h3 class="heading3"><span>Legal/Registered</span></h3>
                <ul>
                    <li><label>Legal/Registered Entity Address</label><textarea placeholder="address"></textarea></li>
                    <li>
                        <label>Country <span>*</span></label>
                        <select>
                            <option>Please Select</option>
                            <option>Please Select</option>
                        </select>
                    </li>
                    <li>
                        <label>Region</label>
                        <select>
                            <option>Please Select</option>
                            <option>Please Select</option>
                        </select>
                    </li>
                    <li>
                        <label>City</label>
                        <select>
                            <option>Please Select</option>
                            <option>Please Select</option>
                        </select>
                    </li>
                    <li>
                        <label>Postal Zip Code</label>
                        <select>
                            <option>Please Select</option>
                            <option>Please Select</option>
                        </select>
                    </li>
                </ul>
                <h3 class="heading3"><span>Events</span></h3>
                <ul>
                    <li><label>Event Title</label><input type="text" placeholder="Event Title" /></li>
                    <li><label>Old Value</label><input type="text" placeholder="Old Value" /></li>
                    <li><label>New Value</label><input type="text" placeholder="New Value" /></li>
                    <li className="btn-list"><div className="SubmitButton text-start"><button>Save</button> <button>Delete</button></div></li>
                </ul>
                <ul>
                    <li><label>Event Status</label><input type="text" placeholder="Event Status" /></li>
                    <li><label>Validation Document</label><input type="file" /></li>
                    <li><label>Event Effective Date</label><input type="date" /></li>
                </ul>
                <h3 class="heading3"><span>Headquarters Entity Address</span></h3>
                <ul>
                    <li><label>Headquarters Entity Address</label><textarea placeholder="address"></textarea></li>
                    <li>
                        <label>Country <span>*</span></label>
                        <select>
                            <option>Please Select</option>
                            <option>Please Select</option>
                        </select>
                    </li>
                    <li>
                        <label>City</label>
                        <select>
                            <option>Please Select</option>
                            <option>Please Select</option>
                        </select>
                    </li>
                    <li>
                        <label>Region <span>*</span></label>
                        <input type="text" placeholder="Region" />
                    </li>
                    
                    <li>
                        <label>Postal Zip Code</label>
                        <input type="text" placeholder="Postal Zip Code" />
                    </li>
                    <li><label>Incorporation Date</label><input type="date" /></li>
                </ul>
                <h3 class="heading3"><span>DIRECT PARENT</span></h3>
                <ul>
                    <li>
                        <label className="label-full">Direct Parent <span>*</span></label>
                        <label className="switch">
                            <i>No</i>
                            <input type="checkbox" />                    
                            <span className="slider round"><i>Yes</i></span>
                        </label>
                    </li>
                    <li>
                        <label>Direct Parent (If Reason is No) <span>*</span></label>
                        <input type="text" placeholder="Direct Parent (If Reason is No)" />
                    </li>
                    {/* <li>
                        <label>Direct Parent Parent (If Yes) <span>*</span></label>
                        <input type="text" placeholder="Direct Parent Parent (If Yes)" />
                    </li> */}
                    <li>
                        <label>Start Date of Relationship <span>*</span></label>
                        <input type="text" placeholder="Start date of relationship" />
                    </li> 
                </ul>
                <h3 class="heading3"><span>ULTIMATE PARENT</span></h3>
                <ul>
                    <li>
                        <label className="label-full">Ultimate Direct Parent <span>*</span></label>
                        <label className="switch">
                            <i>No</i>
                            <input type="checkbox" />                    
                            <span className="slider round"><i>Yes</i></span>
                        </label>
                    </li>
                    <li>
                        <label>Ultimate Present (If Reason is No) <span>*</span></label>
                        <input type="text" placeholder="Ultimate Present (If Reason is No)" />
                    </li>
                    {/* <li>
                        <label>Ultimate Parent has LEI ?  ( If Yes& also same as DP) <span>*</span></label>
                        <input type="text" placeholder="Ultimate Parent has LEI ?  ( If Yes& also same as DP)" />
                    </li> */}
                    <li>
                        <label>Ultimate Parent Name <span>*</span></label>
                        <input type="text" placeholder="Ultimate Parent Name" />
                    </li>
                    <li>
                        <label>Start Date of Relationship <span>*</span></label>
                        <input type="text" placeholder="Start date of relationship" />
                    </li>  
                </ul>
                <h3 class="heading3"><span>LEGAL FORM - BRANCH</span></h3>
                <ul>
                    <li><label>Registration Tab (Project Office)</label><input type="text" placeholder="Registration Tab (Project Office)" /></li>
                    <li>
                        <label>LEI Number (If Yes/No) <span>*</span></label><input type="text" placeholder="LEI Number (If Yes/No)" />
                    </li>
                </ul>
                {/* <h3 class="heading3"><span>PAYMENT</span></h3>
                <ul>
                    <li>
                        <label>Mode Of Payment (Payment gateway) <span>*</span></label><input type="text" placeholder="Mode Of Payment  (Payment gateway)" />
                    </li>
                    <li>
                        <label>GST Number <span>*</span></label><input type="text" placeholder="GST Number" />
                    </li>
                    <li>
                        <label>No of Years <span>*</span></label><input type="text" placeholder="No of Years" />
                    </li>
                </ul> */}   
                {/* <h2 class="heading2 form-heading">Payment</h2> */}
                
                    {/* <li>
                        <label>Mode Of Payment (Payment gateway) <span>*</span></label>
                        <select>
                            <option>NEFT</option>
                            <option>RTGS</option>
                        </select>
                    </li>
                    <li>
                        <label>Tax Payer Type <span>*</span></label>
                        <select>
                            <option>SEZ</option>
                            <option>NON SEZ</option>
                        </select>
                    </li>
                    <li><label>Upload SEZ Declaration </label><input type="file" /></li>
                    <li>
                        <label>GST Number <span>*</span></label><input type="text" placeholder="GST Number" />
                    </li>
                    <li>
                        <label>Payment Amount <span>*</span></label><input type="text" placeholder="Payment Amount" />
                    </li>
                    <li>
                        <label>Proceed to Payment <span>*</span></label><input type="text" placeholder="Proceed to Payment" />
                    </li>
                    <li>
                        <label>No of Years <span>*</span></label><input type="text" placeholder="No of Years" />
                    </li> */}
                    <h2 class="heading2 form-heading">Edit Document Upload (as per legal from)</h2>
                <ul>
                    <li>
                        <label>Letter of Authority <span>*</span></label><input type="file" />
                    </li>
                    <li>
                        <label>Audited Annual Financial Statement / Report (latest available) <span>*</span></label><input type="file" />
                    </li>
                    <li>
                        <label>Consolidated Audited Annual Financial Statement / Report of the direct parent (If Any) <span>*</span></label><input type="file" />
                    </li>
                    <li>
                        <label>Consolidated Audited Annual Financial Statement / Report of the ultimate parent (If Any) <span>*</span></label><input type="file" />
                    </li>
                    <li>
                        <label>Statutory Auditor’s Certificate (if required) <span>*</span></label><input type="file" />
                    </li>
                    <li>
                        <label>Shareholding pattern on company’s letterhead <span>*</span></label><input type="file" />
                    </li>
                </ul>

                <div className="responsive-table">
                    <table>
                        <tbody>
                            <tr>
                                <th>SI.No.</th>
                                <th>Dcument Name</th>
                                <th>Document Value</th>
                                <th>Action</th>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Letter of Authority</td>
                                <td>Letter of Authority.pdf</td>
                                {/* <i class="fas fa-upload"></i> */}
                                <td>
                                    <div class="download-view">                        
                                    <a href="javascript:void(0)"><i class="fas fa-trash-alt"></i></a>                                    
                                    </div>
                                </td>
                            </tr> 
                            <tr>
                                <td>2</td>
                                <td>Audited Annual Financial Statement</td>
                                <td>Audited Annual Financial Statement.pdf</td>
                                <td>
                                    <div class="download-view">                        
                                    <a href="javascript:void(0)"><i class="fas fa-trash-alt"></i></a>
                                    </div>
                                </td>
                            </tr>  
                            <tr>
                                <td>3</td>
                                <td>Consolidated Audited Annual Financial Statement</td>
                                <td>Consolidated Audited Annual Financial Statement.pdf</td>
                                <td>
                                    <div class="download-view">                        
                                    <a href="javascript:void(0)"><i class="fas fa-trash-alt"></i></a>
                                    </div>
                                </td>
                            </tr> 
                            <tr>
                                <td>4</td>
                                <td>Consolidated Audited Annual Financial Statement</td>
                                <td>Consolidated Audited Annual Financial Statement.pdf</td>
                                <td>
                                    <div class="download-view">                        
                                    <a href="javascript:void(0)"><i class="fas fa-trash-alt"></i></a>
                                    </div>
                                </td>
                            </tr> 
                            <tr>
                                <td>5</td>
                                <td>Statutory Auditor’s Certificate</td>
                                <td>Statutory Auditor’s Certificate.pdf</td>
                                <td>
                                    <div class="download-view">                        
                                    <a href="javascript:void(0)"><i class="fas fa-trash-alt"></i></a>
                                    </div>
                                </td>
                            </tr> 
                           
                            <tr>
                                <td>6</td>
                                <td>Shareholding pattern on company’s letterhead</td>
                                <td>Shareholding pattern on company’s letterhead.pdf</td>
                                <td>
                                    <div class="download-view">                        
                                        <a href="javascript:void(0)"><i class="fas fa-trash-alt"></i></a>
                                    </div>
                                </td>
                            </tr>                
                        </tbody>
                    </table>
                </div>










                {/*<h3 className="heading3"><span>Events Status</span></h3>
                <ul>
                    <li>
                        <label>Event title</label>
                        <input type="text" placeholder="In Progress" />
                    </li>
                     <li>
                        <label>Old value</label>
                        <input type="text" placeholder="Old value" />
                    </li>
                    <li>
                        <label>New value</label>
                        <input type="text" placeholder="New value" />
                    </li>
                    <li>
                        <label>Event Status</label>
                        <input type="text" placeholder="Event Status" />
                    </li>
                    <li>
                        <label>Validation document</label>
                        <input type="file" />
                    </li>
                    <li>
                        <label>Event effective date</label>
                        <input type="date" />
                    </li>                     
                </ul>*/}
                {/* <h3 className="heading3"><span>Query</span></h3>
                <ul>
                    <li>
                        <label>Query</label>
                        <select>
                            <option>Dropdown</option>
                            <option>Dropdown2</option>
                        </select>
                    </li>
                    <li className="listing-btn">
                        <input type="submit" value="Check DQ and update" />
                    </li>
                             
                </ul>  
                <h3 className="heading3"><span>Document</span></h3>
                <ul>
                    <li>
                        <label>Upload  <span>*</span></label>
                        <input type="file"  />
                    </li>                 
                </ul> */} 
                <div className="SubmitButton">
                    <button>Modify</button>
                </div>  
            </div>            
        </div>
    )

}
export default ModifyApplication